import { render, staticRenderFns } from "./updFrtt.vue?vue&type=template&id=6c670649"
import script from "./updFrtt.vue?vue&type=script&lang=js"
export * from "./updFrtt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports